import { ApplicationMuiTheme } from 'Lib/themes/muiTheme';

export const muiStyles = (theme: ApplicationMuiTheme) => ({
    root: {
        height: '100%',
        backgroundColor: theme?.app?.applicationColors.backgroundPrimary ||
            '#FFFFFF'
    },
    backButtonContainer: {
        flexBasis: 'auto' as const,
        paddingLeft: '1.5rem',
        paddingTop: '2.5rem'
    },
    headerContainer: {
        flexBasis: 'auto' as const,
        margin: '2.5rem 0',
        paddingLeft: '4rem'
    },
    connectionsContainer: {
        backgroundColor: theme?.app?.applicationColors.enumColors.offWhite ||
            '#F3F3F3',
        padding: '2.5rem 0',
        flexGrow: 1
    },
    noSelectedConnection: {
        paddingTop: '3rem',
        alignSelf: 'center' as const,
        justifySelf: 'center' as const
    },
    apiIcon: {
        height: '90px',
        width: '90px',
        paddingBottom: '.5rem'
    }
});